import { getIn } from '../../utils/getIn';
import { OrderedMap } from 'immutable';
export const findFirstNumberPropertyWithValue = phoneNumberProperties => {
  if (!phoneNumberProperties) return undefined;
  if (OrderedMap.isOrderedMap(phoneNumberProperties)) {
    return phoneNumberProperties.find(propertyDefinition => {
      const propertyValue = propertyDefinition.value;
      return Boolean(propertyValue);
    });
  }
  return Object.values(phoneNumberProperties).find(propertyDefinition => {
    const propertyValue = propertyDefinition.value;
    return Boolean(propertyValue);
  });
};
export const findNumberPropertyNameWithValue = (phoneNumberProperties, numberPropertyName) => {
  if (!phoneNumberProperties) return undefined;
  if (!numberPropertyName) {
    return findFirstNumberPropertyWithValue(phoneNumberProperties);
  }
  if (OrderedMap.isOrderedMap(phoneNumberProperties) || Array.isArray(phoneNumberProperties)) {
    return phoneNumberProperties.find(propertyDefinition => {
      const propertyValue = getIn(['value'], propertyDefinition);
      const propertyName = getIn(['propertyName'], propertyDefinition);
      return propertyValue && propertyName === numberPropertyName;
    });
  }
  const targetProperty = phoneNumberProperties[numberPropertyName];
  return targetProperty !== null && targetProperty !== void 0 && targetProperty.value ? targetProperty : undefined;
};